import { createContext } from 'react';

export interface IncidentDrawerContextType {
	incidentId: string | null;
	openIncident: (incident: string | null) => void;
	opened: boolean;
	close: () => void;
}

export const defaultContext: IncidentDrawerContextType = {
	incidentId: null,
	openIncident: () => {},
	opened: false,
	close: () => {},
};

export const IncidentDrawerContext =
	createContext<IncidentDrawerContextType>(defaultContext);
